import { useDispatch } from 'react-redux';

import { filterClear } from '../redux/actions';

import styles from './ScreenerSettingsActionsComponent.module.scss';

export const ScreenerSettingsActionsComponent = () => {
	const dispatch = useDispatch();

	return (
		<div className={styles.action_container}>
			<button className={styles.action} onClick={() => dispatch(filterClear())}>Очистить</button>
		</div>
	)
};